import React from "react";

const Loading = () => {
  return (
    <div className="h-screen flex justify-center items-center gap-6">
      <button class="btn loading">loading</button>
      <div class="flex items-center justify-center ">
        <div class="w-16 h-16 border-b-2 border-gray-900 rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default Loading;
